import { AuthContext } from "@harvestr-api/common";
import {
    gqlDiscovery,
    gqlGithubIssueCreateWithoutDiscoveryInput
} from "@harvestr-api/models";
import { githubApiService } from "../services/github-api.service";
import { githubWebhookService } from "../services/github-webhook.service";

export const githubIssueFacade = {
    async createIssueAndRegisterWebhook(
        data: {
            harvestrIssue: gqlGithubIssueCreateWithoutDiscoveryInput;
            discovery: Pick<gqlDiscovery, "id" | "title" | "clientId">;
            copyDiscoveryAttachments: boolean;
        },
        context: AuthContext
    ) {
        const fullHarvestrIssue = await githubApiService.createIssue(
            data,
            context
        );
        await githubWebhookService.registerWebhook(
            fullHarvestrIssue?.githubOwnerName || null,
            fullHarvestrIssue?.githubRepositoryName || "",
            context
        );
        return fullHarvestrIssue;
    },
    async linkIssueAndRegisterWebhook(
        data: {
            harvestrIssue: gqlGithubIssueCreateWithoutDiscoveryInput;
            discovery: Pick<gqlDiscovery, "id" | "title">;
            copyDiscoveryAttachments: boolean;
        },
        context: AuthContext
    ) {
        const fullHarvestrIssue = await githubApiService.linkIssue(
            data,
            context
        );
        await githubWebhookService.registerWebhook(
            fullHarvestrIssue?.githubOwnerName || null,
            fullHarvestrIssue?.githubRepositoryName || "",
            context
        );
        return fullHarvestrIssue;
    }
};
